/**
 * @generated SignedSource<<01e36c96aa548633ce7d4bc6167f154c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileSidebarAvatarV2_userProfile$data = {
  readonly avatarImage: {
    readonly id: string;
    readonly uid: string;
    readonly url: string;
  } | null;
  readonly displayUsername: string;
  readonly firstName: string | null;
  readonly hasCompletedIndyOnboarding: boolean;
  readonly lastName: string | null;
  readonly visitorCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"ShareProfileButton_userProfile" | "WorkAvailability_userProfile" | "useUserProfileAvailability_userProfile">;
  readonly " $fragmentType": "ProfileSidebarAvatarV2_userProfile";
};
export type ProfileSidebarAvatarV2_userProfile$key = {
  readonly " $data"?: ProfileSidebarAvatarV2_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileSidebarAvatarV2_userProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileSidebarAvatarV2_userProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUsername",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasCompletedIndyOnboarding",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContraImage",
      "kind": "LinkedField",
      "name": "avatarImage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uid",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShareProfileButton_userProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useUserProfileAvailability_userProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkAvailability_userProfile"
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "2947d564026a439b8ceadaeb286cde0d";

export default node;
